import { render } from "./UnitList.vue?vue&type=template&id=ae8a984a&scoped=true"
import script from "./UnitList.vue?vue&type=script&lang=js"
export * from "./UnitList.vue?vue&type=script&lang=js"

import "./UnitList.vue?vue&type=style&index=0&id=ae8a984a&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae8a984a"]])

export default __exports__